import React, { useState } from 'react'
import { COLORES } from '../../../../config/colores'
import { makeStyles } from '@material-ui/core'
import { renderTextField } from '../../../Forms/fieldRenderers'
import { Field } from 'redux-form'

const useStyles = makeStyles((theme) => ({
  cardHoverEffect: {
    // Estado inicial
    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
    transform: 'scale(1)',
    boxShadow: theme.shadows[2],

    // Estado hover
    '&:hover': {
      transform: 'scale(1.08)',
      boxShadow: theme.shadows[10]
    }
  }
})
)

export default function CampoEditable (props) {
  const { name, titulo, valor, handleDisplayClick, backgroundColor = null } = props
  const [isEditing, setIsEditing] = useState(false)
  const classes = useStyles()

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      props.handleInputBlur()
      setIsEditing(false)
    }
  }

  const handleDisplay = () => {
    handleDisplayClick()
    setIsEditing(true)
  }

  return (
    <div
      className={`animation-flipIny ${classes.cardHoverEffect}`}
      style={{
        display: 'flex',
        justifyContent: 'space-around',
        flexDirection: 'column',
        borderRadius: '18px',
        backgroundColor: backgroundColor || COLORES.grey.dark,
        color: 'white',
        padding: 0
      }}
    >
      {isEditing
        ? <Field
          onKeyDown={handleKeyDown}
          name={name}
          type='number'
          label={titulo}
          component={(fieldProps) => (
            renderTextField({
              ...fieldProps,
              onBlur: props.handleInputBlur,
              wrapperStyle: { margin: 0, padding: 0, minHeight: 'auto', marginBottom: 0 },
              style: {
                width: '100%',
                margin: 0,
                padding: 0,
                textAlign: 'center',
                backgroundColor: backgroundColor || COLORES.grey.dark,
                color: 'white',
                border: '1px solid white'
              }
            })
          )}
          autoFocus
          value={valor}
          style={{ width: 'auto', margin: 'auto', textAlign: 'center' }}
        />
        : <div
          onClick={handleDisplay}
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            cursor: 'pointer',
            padding: '5px 10px',
            minWidth: '80px',
            justifyContent: 'center'
          }}
        >
          {titulo}
          <span
            style={{
              color: 'white',
              backgroundColor: backgroundColor || COLORES.grey.dark,
              fontWeight: 'bold',
              fontSize: '2rem',
              padding: 0,
              borderRadius: '8px'
            }}
          >
            {valor}
          </span>
        </div>
      }
    </div>
  )
}
